import { render, staticRenderFns } from "./CargoStory.vue?vue&type=template&id=917c2058"
import script from "./CargoStory.vue?vue&type=script&lang=js"
export * from "./CargoStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports